import { IScope, IDirectiveFactory, IDirective } from "angular";
import { IModalService } from "angular-ui-bootstrap";

import { IAssigneeIdMap } from "@gtmhub/assignees/models";
import { AssigneeActions, IAssigneesStoreState } from "@gtmhub/assignees";
import { INgRedux } from "@gtmhub/state-management";

interface ISelectAssignees extends IScope {
  targetGroup: string;
  assigneesIdMap: IAssigneeIdMap;
  ngModel: string[];
  openAssigneeSelector(): void;
  removeUserFromSelection(userId: string): void;
}

const bindStateToScope = (state: IAssigneesStoreState) => ({
  assigneesIdMap: state.assignees.map,
});

export class SelectAssignees implements IDirective {
  public scope = {
    targetGroup: "@",
    ngModel: "=",
    ngRequired: "=",
  };
  public restrict = "E";
  public templateUrl = require("../views/select-assignees.jade");

  constructor(private $uibModal: IModalService, private assigneeActions: AssigneeActions, private $ngRedux: INgRedux) {}

  public link(scope: ISelectAssignees): void {
    if (!scope.ngModel) {
      scope.ngModel = [];
    }

    const unsubscribe = this.$ngRedux.connect(bindStateToScope)(scope);
    scope.$on("$destroy", unsubscribe);
    this.$ngRedux.dispatch(this.assigneeActions.getAssignees());

    scope.openAssigneeSelector = (): void => {
      const modal = this.$uibModal.open({
        templateUrl: require("../../assignees/views/select-assignees.jade"),
        windowClass: "medium-small fixed-selector",
        controller: "SelectAssigneesModalCtrl",
        resolve: {
          targetGroup: () => {
            return scope.targetGroup;
          },
          selectedEmployeesOrTeams: () => {
            return scope.ngModel;
          },
        },
      });

      modal.result.then((selectedEmployeesOrTeams) => {
        scope.ngModel = selectedEmployeesOrTeams;
      });
    };

    scope.removeUserFromSelection = (userId: string): void => {
      scope.ngModel = scope.ngModel.reduce((newSelection, currentUserId) => {
        if (currentUserId !== userId) {
          newSelection.push(currentUserId);
        }

        return newSelection;
      }, []);
    };
  }

  public static factory(): IDirectiveFactory {
    const directive = ($uibModal: IModalService, assigneeActions: AssigneeActions, $ngRedux: INgRedux) => new SelectAssignees($uibModal, assigneeActions, $ngRedux);
    directive.$inject = ["$uibModal", "AssigneeActions", "$ngRedux"];
    return directive;
  }
}
